/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Unlimited_WorkspacesInputs */



/**
* | output |
* | --- |
* | "Unlimited spaces, projects, and team members" |
*
* @param {Pricing_Feature_Unlimited_WorkspacesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_unlimited_workspaces = /** @type {((inputs?: Pricing_Feature_Unlimited_WorkspacesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Unlimited_WorkspacesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbegrenzte Spaces, Projekte und Teammitglieder")
	return /** @type {LocalizedString} */ ("Unlimited spaces, projects, and team members")
});